/* eslint-disable */
import '../vendor/iframeResizer.min';
import GetMobileOperatingSystem from "../js/global/mobile-operating-system";

global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

var ran = false;
var mobileOS = GetMobileOperatingSystem();

var windowWidth = $(window).width();

var globalAssetPath = '';

function init(assetPath) {
    globalAssetPath = assetPath;
    initIFrameResizer(); 
    updateBackgroundImages();
}

function initIFrameResizer() {
    //detect Internet Explorer
    var isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g)

     const myIframe = document.querySelector('.form-container iframe');
     if(isIE) {
         //do nothing
     }
     else {
        iFrameResize({
            log:false,
            checkOrigin:false,
            bodyPadding:'0 0 40px 0',
           }, myIframe);
     }
}

function updateBackgroundImages() {
    var elemBG, elemBGName, elemBGStyleName, splitString, endOfUrl, newEndOfUrl = '';
    windowWidth = $(window).width();
    elemBG = $('.featured-header-bg');
    elemBG.each(function(index) {
        if($(this).attr('data-bg') !== undefined) {
            elemBGName, splitString, endOfUrl = '';
            elemBGName = $(this).attr('data-bg');
            splitString = elemBGName.split('/');
            endOfUrl = splitString[(splitString.length) - 1];

            if($(this).attr('style') !== undefined) {
                elemBGStyleName = $(this).attr('style');
                splitString = elemBGStyleName.split('/');
                endOfUrl = splitString[(splitString.length) - 1];
                endOfUrl = endOfUrl.replace('");', '');
            }

            if(windowWidth > 1023) {
                if(endOfUrl !== '') {
                    switch (endOfUrl) {
                        case 'header-bg-mobile.png':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('-mobile', '');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('-mobile', '');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        default:
                            break;
                    }
                }
            }
            else {
                if(endOfUrl != '') {
                    switch (endOfUrl) {
                        case 'header-bg.png':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('header-bg.png', 'header-bg-mobile.png');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('header-bg.png', 'header-bg-mobile.png');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        default:
                            break;
                    }
                }
            }
        }
    });
}

//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        var classes = (e.target.classList);
        if(classes.contains('quote')) {
            if(windowWidth > 1024) {
                bg = bg.replace('-mobile', '');
            }
        }
        e.target.style.backgroundImage = 'url(' + bg + ')';

    }
});

$(window).resize(function() {
    updateBackgroundImages();
});

export default init